module.exports = __webpack_public_path__ + "static/media/3DPPA33.46e8f4bf.jpg";